import { useEffect, useState, useMemo } from "react";
import api from "../lib/api";
import { X } from "lucide-react";

const CATS = [
  {key:"", label:"All"},
  {key:"gaming", label:"Gaming"},
  {key:"second-life", label:"Second Life"},
  {key:"travel", label:"Travel"},
  {key:"creative", label:"Creative"},
  {key:"community", label:"Community"},
];

export default function Gallery() {
  const [items, setItems] = useState([]);
  const [cat, setCat] = useState("");
  const [open, setOpen] = useState(null);

  useEffect(() => {
    api.get("/gallery").then(r => setItems(r.data)).catch(()=>{});
  }, []);

  const filtered = useMemo(() => cat ? items.filter(i => i.category === cat) : items, [items, cat]);

  return (
    <div className="page-container fade-in" data-testid="gallery-page">
      <div className="page-eyebrow">visual archive</div>
      <h1 className="page-title">Gallery</h1>
      <p className="page-sub">Screenshots, photographs, sketches, and quiet moments. Click any frame to look closer.</p>

      <div className="flex flex-wrap gap-2 mt-8" data-testid="gallery-filters">
        {CATS.map(c => (
          <button key={c.key} className="gold-btn" onClick={() => setCat(c.key)}
            data-testid={`gallery-filter-${c.key||"all"}`}
            style={{
              background: cat === c.key ? "var(--gold)" : "transparent",
              color: cat === c.key ? "var(--bg-base)" : "var(--gold)",
            }}>{c.label}</button>
        ))}
      </div>

      <div className="mt-6 columns-1 sm:columns-2 lg:columns-3 gap-4 space-y-4">
        {filtered.map(it => (
          <button key={it.id} className="room-card break-inside-avoid block w-full text-left overflow-hidden" onClick={() => setOpen(it)} data-testid={`gallery-item-${it.id}`}>
            <img src={it.image_url} alt={it.title} className="w-full object-cover"/>
            <div className="p-3">
              <div className="tavern-heading text-base gold-text">{it.title}</div>
              {it.caption && <div className="text-xs mt-1" style={{color:"var(--muted)"}}>{it.caption}</div>}
            </div>
          </button>
        ))}
      </div>

      {open && (
        <div className="fixed inset-0 z-50 grid place-items-center p-4" style={{background:"rgba(0,0,0,0.85)"}} onClick={()=>setOpen(null)} data-testid="gallery-modal">
          <div className="max-w-5xl w-full" onClick={e => e.stopPropagation()}>
            <button className="gold-btn ml-auto flex" onClick={()=>setOpen(null)} data-testid="gallery-modal-close"><X className="h-4 w-4"/> Close</button>
            <img src={open.image_url} alt={open.title} className="w-full max-h-[78vh] object-contain mt-3"/>
            <div className="parchment-card p-4 mt-3">
              <div className="tavern-heading text-xl gold-text">{open.title}</div>
              {open.caption && <div className="text-sm mt-1" style={{color:"var(--muted)"}}>{open.caption}</div>}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
